import { getDocumentationUrl } from '@gonfalon/docs/documentationUrl';
import { type InternalEnvironment } from '@gonfalon/environments/types';
import { getSdkInfoByKey, type SdkKey } from '@gonfalon/sdk-info/sdkInfo';

import { SdkInitIdentifier } from './types';

export const getSdkKeyFromEnvironment = (sdkKey: SdkKey, env: InternalEnvironment) => {
  const identifier = SdkInitIdentifier[sdkKey];

  switch (identifier) {
    case 'mobile':
      return env.mobileKey;
    case 'clientSideId':
      return env._id;
    case 'sdk':
      return env.apiKey;
    default:
      // relay-proxy
      return undefined;
  }
};

export const getSdkDocumentationUrl = (sdk: SdkKey) => {
  const sdkInfo = getSdkInfoByKey(sdk);
  return sdkInfo?.docsPath ? getDocumentationUrl(sdkInfo.docsPath) : getDocumentationUrl('sdk');
};

export const getDemoRequestUrl = () => 'https://launchdarkly.com/request-a-demo/';
